import { useEffect } from "react";

export const useJsonLd = (id, data) => {
  useEffect(() => {
    if (!data) return undefined;
    let el = document.getElementById(id);
    if (!el) { el = document.createElement("script"); el.type = "application/ld+json"; el.id = id; document.head.appendChild(el); }
    el.textContent = JSON.stringify(data);
    return () => el.remove();
  }, [id, JSON.stringify(data)]); // eslint-disable-line react-hooks/exhaustive-deps
};

export const faqLd = (items) => items?.length ? {
  "@context": "https://schema.org", "@type": "FAQPage",
  mainEntity: items.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
} : null;
